// extracted by mini-css-extract-plugin
module.exports = {"nav__submenu-container":"styles_nav__submenu-container___kCTB","nav__submenu-header":"styles_nav__submenu-header__tJP8w"};